import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20"><circle filter="none" transform="translate(10 3)" r="2"/><circle filter="none" transform="translate(10 10)" r="2"/><circle filter="none" transform="translate(10 17)" r="2"/></svg>`;

export { symbol as default };
